import React from 'react';
import {Navbar, Button, Container} from 'react-bootstrap';
import styled from 'styled-components';
import {Link} from 'gatsby';
import {ReactSVG} from 'react-svg';
import {ArrowRightS} from '@styled-icons/remix-fill';
import {useSiteMetadata} from '../hooks/use-site-metadata';
import {withPrefix} from 'gatsby';

const StyledButton = styled(Button)``;

export default function Sidenav(props) {
  const {pdfName, downloadCTA} = useSiteMetadata();
  const url = typeof window !== 'undefined' ? window.location.pathname : '';

  if (url.includes("article")) {
    var hidden = 'visible';
  }
  else {
    var hidden = 'invisible';
  }

  return (
    <Container>
      <Navbar expand="xs">
        <Navbar.Brand>
          <Link to={`https://iuslaboris.com/`}>
            <ReactSVG src={withPrefix('/logo.svg')} />
          </Link>
        </Navbar.Brand>
        <div className={`${hidden}`}>
          <StyledButton
            className="btn btn-primary d-flex align-items-center justify-content-between"
            href={withPrefix(pdfName)}
            download
          >
            <span>{downloadCTA}</span>
            <ArrowRightS size="24" />
          </StyledButton>
        </div>
      </Navbar>
    </Container>
  );
}
